import { Currency } from '@uniswap/sdk-core'
import { HideMedium } from 'pages/Swap/styles'
import styled from 'styled-components/macro'

import { CloseIcon } from '../../theme'
import PageTokensPair from '../PageTokensPair'

interface IChartHeaderProps {
  currency0?: Currency | null
  currency1?: Currency | null
  onCloseMobileChart?: () => void
}

const ChartHeaderWrapper = styled.div`
  width: 100%;
  height: 100px;
  display: grid;
  padding-top: 24px;
  padding-bottom: 24px;
  align-items: center;
  position: relative;
  grid-template-columns: 1fr auto;
  grid-gap: 16px;
  padding-left: 50px;
  @media (max-width: 1200px) {
    padding-left: 16px;
  }
  .close--icon {
    top: 9px;
    right: 9px;
    position: absolute;
  }
`

export default function ChartHeader({ currency0, currency1, onCloseMobileChart }: IChartHeaderProps) {
  return (
    <ChartHeaderWrapper>
      <PageTokensPair
        isMerged
        label={currency0 && currency1 ? 'Pairs' : 'Token'}
        token0Currency={currency0 ? currency0 : currency1 ?? undefined}
        token1Currency={currency0 ? currency1 ?? undefined : undefined}
        currencyLogoSize={52}
      />
      {onCloseMobileChart && (
        <HideMedium>
          <CloseIcon
            size={32}
            strokeWidth={1}
            color="#BCBAAC"
            className="close--icon"
            data-cy="confirmation-close-icon"
            onClick={onCloseMobileChart}
          />
        </HideMedium>
      )}
    </ChartHeaderWrapper>
  )
}
